var map = {
	"./Coffee_None_0d47ff31-6f84-4dbf-8325-21906179a51e.png": 8419,
	"./Coffee_abstract_nature_background_blurred_fireflies_dancing_dar_54ea0705-434a-4c84-95d0-6a707ae9b8cc.png": 8270,
	"./background-2.png": 3233,
	"./background.webp": 5243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9938;